import { render, staticRenderFns } from "./TakeOverAppointment.vue?vue&type=template&id=ce929064&lang=pug&"
import script from "./TakeOverAppointment.vue?vue&type=script&lang=ts&"
export * from "./TakeOverAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports